import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sun, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { jmd } from "@/lib/format";

/* Beauty page spotlight: Morgan's Creek SPF 50, linking straight to the live product record. Renders nothing if the product isn't in the catalogue. */
export function SunscreenSpotlight() {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/products", { params: { merchant: "morgans-creek", q: "sunscreen", limit: 1 } }).then(({ data }) => setP((data.items || data || [])[0] || null)).catch(() => {}); }, []);
  if (!p) return null;
  return (
    <Link to={`/product/${p.id}`} className="group mb-8 flex flex-col sm:flex-row items-center gap-5 rounded-3xl bg-[#f6b53a] text-[#1b1a17] p-5 sm:p-6 overflow-hidden relative" data-testid="sunscreen-spotlight">
      <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-white/30 blur-2xl" />
      <img src={p.image} alt={p.name} className="h-28 w-28 sm:h-32 sm:w-32 rounded-2xl object-cover bg-white shrink-0 group-hover:scale-105 transition-transform" />
      <div className="flex-1 text-center sm:text-left">
        <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider bg-[#1b1a17] text-[#f6b53a] rounded-full px-3 py-1"><Sun size={12} /> Morgan's Creek · SPF 50+ PA++++</span>
        <h3 className="font-display font-extrabold text-2xl sm:text-3xl mt-2">Still skipping sunscreen?</h3>
        <p className="text-sm mt-1 opacity-80">Jamaican sun doesn't take days off. Handmade SPF 50 broad-spectrum protection — {jmd(p.price)}.</p>
      </div>
      <span className="inline-flex items-center gap-2 bg-[#1b1a17] text-white rounded-full px-5 py-2.5 text-sm font-bold group-hover:bg-black transition-colors shrink-0" data-testid="sunscreen-spotlight-cta">Get SPF 50 <ArrowRight size={16} /></span>
    </Link>
  );
}
